import React, { useContext } from 'react'

export const mapContextInitValue = { mapApi: {} }

const ctx = React.createContext(mapContextInitValue)
const { Provider: MapProvider, Consumer: MapConsumer } = ctx

export { MapProvider, MapConsumer }
export const useMapApi = () => useContext(ctx).mapApi
